<script setup>
import CFRoundedButton from '@/ui/RoundedButton/CFRoundedButton.vue';
</script>

<template>
    <CFRoundedButton
        icon="remove"
        color="secondary"
    />
</template>
